import React, { useState, useEffect, useRef } from "react";
import { Form, message } from "antd";
import { ModalForm } from "src/enitities/Modal";
import { NomenclatureForm } from "src/enitities/Form";
import { apiRequests } from "src/shared/api/api";

export default function AddNomenclature({ isOpen, setOpen }) {
  const [form] = Form.useForm();
  const [changeData, setChangeData] = useState(false);
  const [createdRecord, setCreatedRecord] = useState(null);
  const tabsRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      setCreatedRecord(null);
    }
  }, [isOpen]);

  useEffect(() => {
    if (createdRecord?.id && tabsRef.current?.setActiveTab) {
      tabsRef.current.setActiveTab("prices");
    }
  }, [createdRecord?.id]);

  const handleSubmit = async (data) => {
    const payload = data?.[0] || {};
    const response = await apiRequests.nomenclature.post([payload]);
    const raw = response?.data ?? response;
    const created = Array.isArray(raw) ? raw[0] : raw;
    return created;
  };

  const handleAfterSave = (result) => {
    if (result?.id) {
      setCreatedRecord(result);
      message.success("Номенклатура создана. Теперь вы можете добавить цены.");
    }
  };

  return (
    <ModalForm
      title={"Добавить номенклатуру"}
      width={1000}
      isOpen={isOpen}
      setOpen={setOpen}
      formContext={form}
      handleSubmit={handleSubmit}
      changeData={changeData}
      setChangeData={setChangeData}
      onAfterSave={handleAfterSave}
      closeOnSuccess={false}
      createdRecord={createdRecord}
    >
      <NomenclatureForm
        ref={tabsRef}
        formContext={form}
        record={createdRecord}
        withoutImage={true}
        setChangeData={setChangeData}
      />
    </ModalForm>
  );
}
